/* eslint-disable complexity */
import TargetedView from "../TargetedView";
import NonTargetedView from "../NonTargetedView";
import { useEffect, useState } from "react";
import { isAuthenticated, promptLogin } from "../../utilities/identityUtils";
import { getCustomerTierId, getConfig } from "../../utilities/loyaltyUtils";
import LoyaltyProgressIndicator from "../../components/progress-indicator";
import PropTypes from "prop-types";
import { loyaltyCustomerCheck } from "../../helpers/isLoyaltyAvailableToCustomer";
import { getSegmentIds } from "../../utilities/getSegmentIds";
import { useJoinStatus } from "../../context/join-status";
import noticeError from "../../utilities/notice-error";
import {
  setErrorCode,
  setLoyaltyData,
  setCurrentTierId,
} from "../../state/join-loyalty/reducer";

export default function LoyaltyView({ appConfig, assetsUrl }) {
  const [loaded, setLoaded] = useState(false);
  const [loyaltyAvailableToCustomer, setloyaltyAvailableToCustomer] =
    useState(false);
  const [, dispatch] = useJoinStatus();
  const [isAnonymous, setIsAnonymous] = useState(false);

  const inviteOnlyOverride = appConfig?.inviteOnlyOverride === "true";

  const userIsInvited = () => {
    if (typeof window === "undefined") {
      return undefined;
    } else {
      return window.location.hash.includes("invited=true");
    }
  };

  useEffect(() => {
    const getConfigForTable = async () => {
      try {
        const loyaltyConfig = await getConfig();
        dispatch(setLoyaltyData(loyaltyConfig));
      } catch (e) {
        noticeError(e);
        return;
      }
    };

    const determineTargetedCustomer = async (inviteOnlyOverride) => {
      getConfigForTable();
      const authenticated = await isAuthenticated();
      if (!authenticated && inviteOnlyOverride) {
        setIsAnonymous(true);
        setloyaltyAvailableToCustomer(true);
        setLoaded(true);
      } else {
        if (!authenticated && !inviteOnlyOverride && userIsInvited()) {
          await promptLogin();
        }

        try {
          const currentTierId = await getCustomerTierId();

          if (currentTierId) {
            dispatch(setCurrentTierId(currentTierId));
            setloyaltyAvailableToCustomer(true);
          } else {
            const segments = await getSegmentIds();
            // await has ben added here for unit test to pass
            const loyaltyCheck = await loyaltyCustomerCheck({
              appConfig,
              segments,
            });
            if (loyaltyCheck) {
              setloyaltyAvailableToCustomer(true);
            }
          }
        } catch (e) {
          const errorCode = e?.response?.data[0]?.errorCode;
          dispatch(setErrorCode(errorCode ? errorCode : e));
        }
        setLoaded(true);
      }
    };

    determineTargetedCustomer(inviteOnlyOverride);
  }, [appConfig, dispatch, inviteOnlyOverride]);

  return (
    <>
      {loaded ? (
        <>
          {inviteOnlyOverride || loyaltyAvailableToCustomer ? (
            <TargetedView assetsUrl={assetsUrl} isAnonymous={isAnonymous} />
          ) : (
            <NonTargetedView assetsUrl={assetsUrl} />
          )}
        </>
      ) : (
        <LoyaltyProgressIndicator />
      )}
    </>
  );
}

LoyaltyView.propTypes = {
  appConfig: PropTypes.object,
  assetsUrl: PropTypes.string,
};
